import React from 'react';

function OptionButton({ children, selected, onClick, className }) {
  const baseClasses = "option-button w-auto inline-flex items-center justify-center";
  const selectedClass = selected ? "selected" : "";
  const combinedClasses = `${baseClasses} ${selectedClass} ${className || ""}`;
  
  return (
    <button onClick={onClick} className={combinedClasses}>
      <span className="font-sans text-base" style={{ color: '#333' }}>{children}</span>
    </button>
  );
}

export default OptionButton;
